import {clsx} from '@gfiber/typesmith';
import {Accordion as BaseAccordion} from '@base-ui/react/accordion';
import type * as React from 'react';
import styles from './Accordion.module.scss';
import 'material-icons/iconfont/material-icons.css';

export interface AccordionSummaryProps {
  text?: string;
  metaIcon?: React.ReactNode;
  onClick?: () => void;
  children?: React.ReactNode;
  triggerLeftClassName?: string;
  summaryContentClassName?: string;
  customTriggerIcon?: React.ReactNode;
  triggerIconClassName?: string;
  [key: string]: unknown;
}

export const AccordionSummary: React.FC<AccordionSummaryProps> = ({
  text,
  metaIcon,
  onClick,
  children,
  triggerLeftClassName,
  summaryContentClassName,
  customTriggerIcon,
  triggerIconClassName,
  ...rest
}) => {
  return (
    <BaseAccordion.Header className={styles.header}>
      <BaseAccordion.Trigger
        {...rest}
        className={clsx(styles.trigger, rest.className as string)}
        onClick={onClick}
      >
        <div className={clsx(styles.triggerLeft, triggerLeftClassName)}>
          {metaIcon && <span className={styles.metaIcon}>{metaIcon}</span>}
          <div className={clsx(styles.summaryContent, summaryContentClassName)}>
            {text && <span>{text}</span>}
            {children}
          </div>
        </div>

        <div className={clsx(styles.triggerIcon, triggerIconClassName)}>
          {customTriggerIcon ?? (
            <span className="material-icons">keyboard_arrow_down</span>
          )}
        </div>
      </BaseAccordion.Trigger>
    </BaseAccordion.Header>
  );
};
